 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"About":"About","Again~Analysis~Answer~OptionTopic~Practice":"Again~Analysis~Answer~OptionTopic~Practice","Answer":"Answer","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice","Again~Analysis~OptionTopic~Practice":"Again~Analysis~OptionTopic~Practice","Again":"Again","Analysis":"Analysis","OptionTopic":"OptionTopic","Practice":"Practice","AuditionInfo":"AuditionInfo","Index":"Index","MyClass":"MyClass","Audition":"Audition","Chapter":"Chapter","Collect":"Collect","Course":"Course","Details":"Details","Downloadapp":"Downloadapp","Everyday":"Everyday","ForgetPwd~Register":"ForgetPwd~Register","ForgetPwd":"ForgetPwd","Register":"Register","Info":"Info","Information":"Information","Introduce":"Introduce","Login":"Login","ModelPaper":"ModelPaper","Personal":"Personal","Phone":"Phone","Record":"Record","ReportCard":"ReportCard","Result":"Result","Servewx":"Servewx","Teachers":"Teachers","TrueTopic":"TrueTopic","Whole~Wrong":"Whole~Wrong","Whole":"Whole","Wrong":"Wrong","WrongAnalysis":"WrongAnalysis","WrongQuestion":"WrongQuestion","modelPaperdetail":"modelPaperdetail","simulation":"simulation"}[chunkId]||chunkId) + "." + {"About":"07bed2f8","Again~Analysis~Answer~OptionTopic~Practice":"8619231f","Answer":"dc1a8de4","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"aab62d86","Again~Analysis~OptionTopic~Practice":"11397da4","Again":"2394cd54","Analysis":"ef74d0bd","OptionTopic":"f1b0adb2","Practice":"e4ef7fa1","AuditionInfo":"dc0c910d","Index":"be0d4531","MyClass":"c62d9679","Audition":"a7cb1859","Chapter":"eb03fbaa","Collect":"91665908","Course":"ccd0603a","Details":"894fca94","Downloadapp":"ed130f07","Everyday":"e8031b51","ForgetPwd~Register":"11300718","ForgetPwd":"c21fb848","Register":"6b9bf453","Info":"760551f2","Information":"37170521","Introduce":"4751abdb","Login":"6f180c06","ModelPaper":"eea1ad7e","Personal":"6e1eaa23","Phone":"990f252f","Record":"f5af9f5b","ReportCard":"70abb415","Result":"0f93a1c7","Servewx":"f5d53e6e","Teachers":"de57b980","TrueTopic":"e0442ae0","Whole~Wrong":"1bb5520a","Whole":"4102880e","Wrong":"e8d14068","WrongAnalysis":"8eae0473","WrongQuestion":"cd251144","modelPaperdetail":"3edee057","simulation":"33dcd215"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"About":1,"Again~Analysis~Answer~OptionTopic~Practice":1,"Answer":1,"Again~Analysis~OptionTopic~Practice":1,"Again":1,"Analysis":1,"OptionTopic":1,"Practice":1,"AuditionInfo":1,"Index":1,"MyClass":1,"Audition":1,"Chapter":1,"Collect":1,"Course":1,"Details":1,"Downloadapp":1,"Everyday":1,"ForgetPwd":1,"Register":1,"Info":1,"Information":1,"Introduce":1,"Login":1,"ModelPaper":1,"Personal":1,"Phone":1,"Record":1,"ReportCard":1,"Result":1,"Servewx":1,"Teachers":1,"TrueTopic":1,"Whole":1,"Wrong":1,"WrongAnalysis":1,"WrongQuestion":1,"modelPaperdetail":1,"simulation":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"About":"About","Again~Analysis~Answer~OptionTopic~Practice":"Again~Analysis~Answer~OptionTopic~Practice","Answer":"Answer","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice","Again~Analysis~OptionTopic~Practice":"Again~Analysis~OptionTopic~Practice","Again":"Again","Analysis":"Analysis","OptionTopic":"OptionTopic","Practice":"Practice","AuditionInfo":"AuditionInfo","Index":"Index","MyClass":"MyClass","Audition":"Audition","Chapter":"Chapter","Collect":"Collect","Course":"Course","Details":"Details","Downloadapp":"Downloadapp","Everyday":"Everyday","ForgetPwd~Register":"ForgetPwd~Register","ForgetPwd":"ForgetPwd","Register":"Register","Info":"Info","Information":"Information","Introduce":"Introduce","Login":"Login","ModelPaper":"ModelPaper","Personal":"Personal","Phone":"Phone","Record":"Record","ReportCard":"ReportCard","Result":"Result","Servewx":"Servewx","Teachers":"Teachers","TrueTopic":"TrueTopic","Whole~Wrong":"Whole~Wrong","Whole":"Whole","Wrong":"Wrong","WrongAnalysis":"WrongAnalysis","WrongQuestion":"WrongQuestion","modelPaperdetail":"modelPaperdetail","simulation":"simulation"}[chunkId]||chunkId) + "." + {"About":"dbd33e3f","Again~Analysis~Answer~OptionTopic~Practice":"260fce0b","Answer":"8c5d8661","Again~Analysis~AuditionInfo~Index~MyClass~OptionTopic~Practice":"31d6cfe0","Again~Analysis~OptionTopic~Practice":"ebe0fe4e","Again":"841fe557","Analysis":"dfb1ec07","OptionTopic":"a0e35558","Practice":"7c135fb3","AuditionInfo":"f8bec6db","Index":"14fcb91e","MyClass":"e78fd985","Audition":"7aba5ce2","Chapter":"503dcb5a","Collect":"f87589ea","Course":"be42583a","Details":"35904cab","Downloadapp":"76b0e86d","Everyday":"986c473c","ForgetPwd~Register":"31d6cfe0","ForgetPwd":"52f0c6b4","Register":"8c6701c5","Info":"809b38e4","Information":"c7e7f058","Introduce":"f178d189","Login":"b5c065d5","ModelPaper":"c178f6ea","Personal":"486f4af3","Phone":"fcb456f5","Record":"a58e5135","ReportCard":"be961df3","Result":"9261e223","Servewx":"b6dcb577","Teachers":"9e8db125","TrueTopic":"e0d1d5e4","Whole~Wrong":"31d6cfe0","Whole":"2f9fe359","Wrong":"6de6f24e","WrongAnalysis":"bddfdbfd","WrongQuestion":"0a5b81c5","modelPaperdetail":"8a99723a","simulation":"9bb949ff"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
